// extracted by mini-css-extract-plugin
export default {"wrapper":"textbutton_wrapper__mgZn4"};